module.exports = __webpack_public_path__ + "img/smalllogo.5b6eb593.png";